import React from 'react'
import { FormControlLabel, Switch } from '@mui/material';

export default function MuiCheckbox(props) {

    const { label = '', labelPlacement = 'end', checked, onClick, sx, disabled } = props

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={checked}
                    onClick={onClick}
                    sx={{ sx }}
                />
            }
            label={label}
            labelPlacement={labelPlacement}
            disabled={disabled} />
    )
}
